/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import BaseApi from '../api/BaseApi';
import configProxy from '../config';
import {UserApi as Contract, UserInfo} from '@adobe/exc-app/user';
import {Events} from '../Events';
import {messenger} from '../Messenger';
import Metrics from '../metrics';

export class UserApi extends BaseApi implements Contract {
  public get: <T extends keyof UserInfo>(type: T) => Promise<UserInfo[T]> = this._get as <T extends keyof UserInfo>(type: T) => Promise<UserInfo[T]>;
  public apiEvents: string[] = [
    'imsOrg',
    'imsOrgName',
    'imsOrgs',
    'imsToken',
    'imsProfile',
    'locale',
    'preferredLanguages',
    'sandbox',
    'sandboxes',
    'subOrg',
    'tenant'
  ];
  public keyPrefix = 'user';
  public metrics = Metrics.create('exc.module-runtime');

  public authExpired() {
    this.metrics.event('Runtime.authExpired');
    messenger.send(Events.AUTH_EXPIRATION, {});
  }

  public get logoutUrl(): string | undefined {
    return configProxy.get('logoutUrl');
  }

  public set logoutUrl(value: string | undefined) {
    configProxy.set({logoutUrl: value});
  }
}

let instance: UserApi;
export default function user() {
  if (!instance) {
    instance = new UserApi(messenger);
  }
  return instance;
}
